import React, { useState, useEffect, useRef, createRef } from "react";

import { useDispatch, useSelector, shallowEqual } from "react-redux";

import { numberWithCommas } from "../../../utils/helpers";
import {
  Table,
  Tooltip,
  Tag,
  Form,
  Input,
  Button,
  Space,
  Modal,
  Descriptions,
  Divider,
  Statistic,
  Col,
  Popconfirm,
  Collapse,
  Select,
  DatePicker,
  List,
  InputNumber,
  TimePicker,
  Checkbox,
  message,
} from "antd";
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  UserOutlined,
  VideoCameraOutlined,
  UploadOutlined,
  DeploymentUnitOutlined,
  SearchOutlined,
  EditOutlined,
  PlusOutlined,
  SaveOutlined,
  ShoppingCartOutlined,
  DeleteOutlined,
  QrcodeOutlined,
} from "@ant-design/icons";

import "./styles.scss";
import Beep from "./Beep.mp3";
import successfx from "./success.mp3";
import errorfx from "./error.mp3";

import moment from "moment";
import {
  getData,
  editItem,
  addItem,
  deleteItem,
  updateItem,
} from "../../../Redux/actions/crudActions";
import { setPrice } from "../../../Redux/actions/productActions";
import {
  addCartItem,
  getCart,
  deleteCartItem,
  editCartItem,
  clearCart,
} from "../../../Redux/actions/cartActions";
import {
  createPackage,
  getPackageData,
  retrievePackage,
  readyShip,
  completePackage,
} from "../../../Redux/actions/packageActions";

import { errorParser, camelToSentence } from "../../../utils/helpers";

import CreateForm from "../../Generic/CreateForm";
import InputSelect from "../../Generic/InputSelect";
import ImageChecker from "../../Generic/ImageChecker";
import ShipPackage from "../ShipPackage";
import QrReader from "react-qr-scanner";
import useSound from "use-sound";
import ErrorList from "antd/lib/form/ErrorList";

import QRcomponent from "./qrcomponent";

const { RangePicker } = DatePicker;
const { Panel } = Collapse;
const { Option } = Select;

const Index = ({ onCloseModal, showButton }) => {
  const dispatch = useDispatch();
  const { user, cart, locations } = useSelector(
    (state) => ({
      user: state.auth.user,
      cart: state.cart.data,
      locations: state.locations.locations,
    }),
    shallowEqual
  );

  const [playbeep] = useSound(Beep);
  const [playsuccess] = useSound(successfx);
  const [playerror] = useSound(errorfx);

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalWidth, setmodalWidth] = useState("80%");
  const [loading, setLoading] = useState(false);
  const [scanLoading, setScanLoading] = useState(false);

  const [setProccessloading, setSetProccessLoading] = useState(false);

  const [destination, setDestination] = useState(null);
  const [destinationName, setDestinationName] = useState(null);
  const [currentItem, setCurrentItem] = useState(null);

  const [packItems, setPackItems] = useState([]);

  const [currentPackID, setCurrentPackID] = useState(null);
  const [currentScanned, setCurrentScanned] = useState(null);

  const [scannedItems, setScannedItems] = useState([]);
  const [kulang, setKulang] = useState(false);
  const [allScanned, setAllScanned] = useState(false);
  const [cameraID, setCameraID] = useState(null);
  const [cameras, setCameras] = useState([]);
  const [width, setWidth] = useState(window.innerWidth);

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }

  useEffect(() => {
    if (!cameraID) {
      getCameras();
    }
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  useEffect(() => {
    // console.log(scannedItems)
    if (packItems.length > 0 && scannedItems.length > 0) {
      var goods = true;
      packItems.map((item) => {
        // console.log(item)
        var currentcount = countOccurrences(scannedItems, item.product);
        // console.log(currentcount , item.quantity)
        if (currentcount < item.quantity) {
          goods = false;
        }
      });
      if (goods) {
        message.success("all scanned");
        setAllScanned(true);
        playsuccess();
        setSetProccessLoading(false);
      }
    }
  }, [scannedItems]);

  useEffect(() => {
    // console.log(scannedItems)
    if (scanLoading) {
      setTimeout(function () {
        setScanLoading(false);
      }, 3000);
    }
  }, [scanLoading]);

  const countOccurrences = (arr, val) =>
    arr.reduce((a, v) => (v === val ? a + 1 : a), 0);

  const scanChecker = (current) => {
    if (current) {
      var textArr = current.split("_");
      if (textArr[0] == "pck" || textArr[0] == "pckitem") {
        var newID = textArr[1];
        if (newID !== currentPackID) {
          setCurrentPackID(newID);
          if (currentPackID) {
            setScannedItems([current]);
            resetModal();
          }
        } else {
          // if(!scannedItems.includes(newID)){
          //   setScannedItems(scannedItems => [...scannedItems, text]);
          // }
        }
      }
      if (textArr[0] == "prod") {
        var newID = textArr[1];
        var packItemsprods = packItems.map((pki) => {
          return pki.product;
        });
        if (packItemsprods.includes(newID)) {
          var currentthing = packItems.filter((pki) => pki.product == newID);
          currentthing = currentthing[0];
          if (
            parseFloat(currentthing.quantity) >
              parseFloat(currentthing.source[`${user.branch}_count`]) &&
            currentItem.dest.id !== user.branch
          ) {
            playerror();
            message.error("product warehouse quantity insufficient");
          } else {
            var scannedcount = countOccurrences(scannedItems, newID);
            // console.log(scannedcount,newID)
            if (scannedcount < currentthing.quantity) {
              setScannedItems((scannedItems) => [...scannedItems, newID]);
              message.success(
                `${currentthing.product_name} : ${scannedcount + 1} of ${
                  currentthing.quantity
                }`
              );
            } else if (scannedcount >= currentthing.quantity) {
              playerror();
              message.warning("you already have scanned the right amount");
            }
          }
        } else {
          playerror();
          message.error("product not part of list");
        }
      }
    }
  };

  useEffect(() => {
    if (currentPackID) {
      getThePackage(currentPackID);
    }
  }, [currentPackID]);

  const getCameras = () => {
    navigator.mediaDevices
      .enumerateDevices()
      .then((devices) => {
        const videoSelect = [];
        devices.forEach((device) => {
          if (device.kind === "videoinput") {
            videoSelect.push(device);
          }
        });
        return videoSelect;
      })
      .then((devices) => {
        // console.log(devices)
        setCameras(devices);
        setCameraID(devices[0].deviceId);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getThePackage = (id) => {
    dispatch(retrievePackage(id)).then((res) => {
      var dest = locations.filter((i) => i.id == res.destination);
      var destData = dest[0];
      if (destData) {
        res["dest"] = destData;
      }
      console.log(res);
      setCurrentItem(res);
    });
  };

  useEffect(() => {
    if (currentItem) {
      setIsModalVisible(true);
      // console.log(currentItem.items)
      // var sortedItems = currentItem.items.sort((a,b) =>(a?.source?.need_scan && !b?.source?.need_scan) ? 1 : ((b?.source?.need_scan && !a?.source?.need_scan) ? -1 : 0) )
      setPackItems(currentItem.items);
      var userbranch = user.branch;
      currentItem.items.map((item) => {
        if (
          item?.source?.[`${userbranch}_count`] &&
          currentItem?.status == "toPack"
        ) {
          var avaialble = item?.source?.[`${userbranch}_count`];
          if (parseFloat(avaialble) < parseFloat(item.quantity)) {
            message.error(`${item.product_name} insufficient`);
            setKulang(true);
          }
        }
      });
    }
  }, [currentItem]);

  const readyToShip = () => {
    console.log(currentItem);

    dispatch(readyShip(currentItem)).then((res) => {
      message.success("Package is Ready to Ship");
      setLoading(false);
      onCloseModal();
      closeModal();
    });
  };

  const recievePackage = () => {
    // console.log(currentItem)
    setLoading(true);
    dispatch(completePackage(currentItem)).then((res) => {
      message.success("Package Has Been Accepted");
      setLoading(false);
      onCloseModal();
      closeModal();
    });
  };

  const footer = () => {
    return (
      <div className="cartFooter">
        {currentItem &&
        currentItem.status == "toShip" &&
        (user.role == "admin" ||
          user.role == "manager" ||
          user.role == "warehouse") ? (
          <ShipPackage
            currentItem={currentItem}
            onCloseModal={() => {
              onCloseModal();
              closeModal();
            }}
          />
        ) : null}

        {currentItem &&
        currentItem.status == "toPack" &&
        (user.role == "admin" ||
          user.role == "manager" ||
          user.role == "warehouse") ? (
          user.branch == currentItem.destination ? (
            <Button
              type="primary"
              loading={loading}
              onClick={() => {
                if (!loading) {
                  setLoading(true);
                  recievePackage();
                }
              }}
            >
              Receive Package
            </Button>
          ) : !kulang && allScanned ? (
            <Button
              type="primary"
              loading={loading}
              onClick={() => {
                if (!loading) {
                  setLoading(true);
                  readyToShip();
                }
              }}
            >
              Ready for Shipping
            </Button>
          ) : null
        ) : null}
        {currentItem &&
        currentItem.status == "shipping" &&
        (user.role == "admin" ||
          user.role == "manager" ||
          user.role == "oic") ? (
          <Button
            type="primary"
            loading={loading}
            onClick={() => {
              recievePackage();
            }}
          >
            Receive Package
          </Button>
        ) : null}

        <div className="destination"></div>
      </div>
    );
  };

  const closeModal = () => {
    setIsModalVisible(false);
    setCurrentScanned(null);
    setCurrentPackID(null);
    setCurrentItem(null);
    setScannedItems([]);
    resetModal();
  };

  const resetModal = () => {
    setPackItems([]);

    setKulang(false);
    setAllScanned(false);
  };

  const somethingScanned = (event) => {
    var text = event.text;
    setScanLoading(true);
    // console.log(text)

    if (text) {
      var textArr = text.split("_");
      if (
        textArr[0] == "pck" ||
        textArr[0] == "pckitem" ||
        textArr[0] == "prod"
      ) {
        // message.success(`scanned ${textArr.join(' ')}`)
        playbeep();
        if (textArr[0] == "prod" && currentItem == null) {
          playerror();
          message.error("Scan Package Waybill First");
        } else {
          setCurrentScanned(text);
          scanChecker(text);
        }
      }
    }
  };

  const packthisItem = (item) => {
    var newArr = [];
    for (let i = 0; i < item.quantity; i++) {
      newArr.push(item.product);
    }
    playbeep();
    setScannedItems((scannedItems) => [...scannedItems, ...newArr]);
  };

  const packthisScannedItem = (item, currentscannedqty) => {
    var newArr = [];
    var qty = item.quantity - currentscannedqty;
    for (let i = 0; i < qty; i++) {
      newArr.push(item.product);
    }
    playbeep();
    setScannedItems((scannedItems) => [...scannedItems, ...newArr]);
  };

  const thiscamera = () => {
    return cameraID;
  };

  const iOS = () => {
    return (
      [
        "iPad Simulator",
        "iPhone Simulator",
        "iPod Simulator",
        "iPad",
        "iPhone",
        "iPod",
      ].includes(navigator.platform) ||
      // iPad on iOS 13 detection
      (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    );
  };

  return (
    <>
      {showButton ? (
        <div className={"scanButton"}>
          <Button
            onClick={() => {
              setIsModalVisible(true);
            }}
            type={"primary"}
            shape={"round"}
            icon={<QrcodeOutlined />}
          >
            Scan QR
          </Button>
        </div>
      ) : (
        <div
          onClick={() => {
            setIsModalVisible(true);
          }}
        >
          SCAN
        </div>
      )}

      {isModalVisible ? (
        <Modal
          title={"SCAN QR"}
          visible={isModalVisible}
          footer={footer()}
          onCancel={() => {
            closeModal();
          }}
        >
          <div className="cart-content">
            <select
              onChange={(e) => {
                setCameraID(e.target.value);
              }}
            >
              {cameras.map((cam, index) => {
                return (
                  <React.Fragment key={cam.deviceId}>
                    <option value={cam.deviceId}>
                      {cam.label || `camera ${index}`}
                    </option>
                  </React.Fragment>
                );
              })}
            </select>
            <QRcomponent
              width={width}
              cameraID={thiscamera()}
              onScan={(e) => {
                if (e && !scanLoading) {
                  somethingScanned(e);
                }
              }}
            />
            {currentItem ? (
              <div
                className={
                  scannedItems.includes(`pck_${currentItem.id}`) &&
                  currentItem.status == "toPack"
                    ? "orderTitleCard scanned"
                    : "orderTitleCard"
                }
              >
                <div className={"firspart"}>
                  <div className={"desc"}>
                    <span className={"label"}>Order Id:</span>{" "}
                    <span className={"val"}> {currentItem.id} </span>
                  </div>
                  <div className={"desc"}>
                    <span className={"label"}>Contact Person: </span>{" "}
                    <span className={"val"}>
                      {currentItem.dest.contact_person}
                    </span>
                  </div>
                  <div className={"desc"}>
                    <span className={"label"}>Contact No: </span>{" "}
                    <span className={"val"}>{currentItem.dest.contactno}</span>
                  </div>
                  <div className={"desc"}>
                    <span className={"label"}>Destination: </span>{" "}
                    <span className={"val"}>{currentItem.dest.name}</span>
                  </div>
                  <div className={"desc"}>
                    <span className={"label"}>Address: </span>{" "}
                    <span className={"val"}>{currentItem.dest.address}</span>
                  </div>
                </div>
                <div className={"qtypart"}>
                  <span>Status</span>
                  <h3>{camelToSentence(currentItem.status)}</h3>
                  <span>Items</span>
                  <h1>{currentItem.items.length}</h1>
                </div>
              </div>
            ) : null}
            {currentItem &&
            (currentItem.status == "shipping" ||
              currentItem.status == "completed") ? (
              <div className={"orderTitleCard"}>
                <div className={"firspart"}>
                  <div className={"desc"}>
                    <span className={"label"}>Courrier:</span>{" "}
                    <span className={"val"}>
                      {" "}
                      {currentItem.shipping_method_name}{" "}
                    </span>
                  </div>
                  <div className={"desc"}>
                    <span className={"label"}>Driver: </span>{" "}
                    <span className={"val"}>{currentItem.shipping_driver}</span>
                  </div>
                  <div className={"desc"}>
                    <span className={"label"}>Driver Phone: </span>{" "}
                    <span className={"val"}>
                      {currentItem.shipping_contact}
                    </span>
                  </div>
                  <div className={"desc"}>
                    <span className={"label"}>Plate no: </span>{" "}
                    <span className={"val"}>{currentItem.shipping_plate}</span>
                  </div>
                  <div className={"desc"}>
                    <span className={"label"}>Tracking: </span>
                    <a
                      href={currentItem.shipping_url}
                      target="_blank"
                      className={"val"}
                      rel="noreferrer"
                    >
                      Click Here
                    </a>
                  </div>
                </div>
                <div className={"qtypart"}>
                  <span>Shipping Fee</span>

                  <h1>{currentItem.shipping_fee}</h1>
                </div>
              </div>
            ) : null}
            <Divider orientation="left">Items</Divider>

            <List
              className="demo-loadmore-list"
              itemLayout="horizontal"
              dataSource={packItems}
              renderItem={(item) => {
                var userbranch = user.branch;
                var error = false;
                var missing = false;
                var complete = false;

                if (
                  item?.source?.[`${userbranch}_count`] &&
                  currentItem?.status == "toPack"
                ) {
                  var avaialble = item?.source[`${userbranch}_count`];
                  avaialble = parseFloat(avaialble);
                  if (
                    avaialble < item?.quantity &&
                    currentItem.dest.id !== user.branch
                  ) {
                    error = true;
                  }
                }

                var currentCount = countOccurrences(scannedItems, item.product);
                if (currentItem.status == "toPack") {
                  if (currentCount > 0 && currentCount < item.quantity) {
                    missing = true;
                  }
                  if (currentCount == item.quantity) {
                    complete = true;
                  }
                }

                var needScan = false;
                if (!item.source) {
                  console.log(item);
                }
                // if(item.source.need_scan){
                //   needScan =true
                // }

                return (
                  <List.Item
                    className={
                      error
                        ? "kulang"
                        : missing
                        ? "missing"
                        : complete
                        ? "scanned"
                        : ""
                    }
                    actions={
                      [
                        // <Button type='link' onClick={()=>{deleteThis(item.id)}}>
                        //   <DeleteOutlined  />
                        // </Button>
                      ]
                    }
                  >
                    <List.Item.Meta
                      avatar={
                        <ImageChecker
                          url={`${process.env.REACT_APP_AWS_S3}${item.product}.png`}
                          success={
                            <img
                              src={`${process.env.REACT_APP_AWS_S3}${item.product}.png`}
                              alt="image"
                              className={"prodimage"}
                            />
                          }
                          fail={
                            <img
                              src={`${process.env.REACT_APP_AWS_S3}logo.jpg`}
                              alt="image"
                              className={"prodimage"}
                            />
                          }
                        />
                      }
                      title={item.product_name}
                      description={
                        <div className="itemdesc">
                          {item?.source?.sku ? (
                            <span>{item.source.sku}</span>
                          ) : null}
                          {avaialble &&
                          (user.role == "admin" ||
                            user.role == "manager" ||
                            user.role == "warehouse") ? (
                            <span>
                              available:{" "}
                              {numberWithCommas(avaialble.toFixed(2))}
                            </span>
                          ) : null}
                        </div>
                      }
                    />
                    {currentItem.status == "toPack" &&
                    user.branch !== currentItem.destination ? (
                      needScan ? (
                        <div className="horizontal">
                          <div className="qtyItem">
                            <h1>
                              {currentCount}/{item.quantity}
                            </h1>
                            <span>
                              {item.unit}
                              {item.quantity > 1 ? "s" : ""}
                            </span>
                          </div>
                          {currentCount > 0 ? (
                            <div className="qtyItem">
                              <Button
                                type={
                                  currentCount >= item.quantity
                                    ? "dashed"
                                    : "primary"
                                }
                                size={"large"}
                                onClick={() => {
                                  if (
                                    currentCount < item.quantity &&
                                    !setProccessloading
                                  ) {
                                    setSetProccessLoading(true);
                                    packthisScannedItem(item, currentCount);
                                  }
                                }}
                              >
                                {currentCount >= item.quantity
                                  ? "Packed"
                                  : "Pack"}
                              </Button>
                            </div>
                          ) : null}
                        </div>
                      ) : (
                        <div className="horizontal">
                          <div className="qtyItem">
                            <h1>{item.quantity}</h1>
                            <span>
                              {item.unit}
                              {item.quantity > 1 ? "s" : ""}
                            </span>
                          </div>
                          {error ? null : (
                            <div className="qtyItem">
                              <Button
                                type={complete ? "dashed" : "primary"}
                                size={"large"}
                                onClick={() => {
                                  if (!complete) {
                                    packthisItem(item);
                                  }
                                }}
                              >
                                {complete ? "Packed" : "Pack"}
                              </Button>
                            </div>
                          )}
                        </div>
                      )
                    ) : (
                      <div className="qtyItem">
                        <h1>{item.quantity}</h1>
                        <span>
                          {item.unit}
                          {item.quantity > 1 ? "s" : ""}
                        </span>
                      </div>
                    )}
                    {/* <div className="vertical">
                    <InputNumber min={0} size={'large'} defaultValue={item.quantity} onChange={(e)=>{changeCartCount(item.id,e)}}  />
                    <span>{item.unit}</span>
                  </div> */}
                  </List.Item>
                );
              }}
            />
          </div>
        </Modal>
      ) : null}
    </>
  );
};

export default Index;
